import produce from 'immer'

export default (state = {}, action) => produce(state, draft => {
  switch (action.type) {
  case 'LOAD_GEO_OBJECTS_SUCCESS':
    action.geoObjects.forEach(obj => {
      draft[obj.id] = obj
    })
    return
  case 'LOAD_GEO_OBJECT_SUCCESS':
  case 'CREATE_GEO_OBJECT_SUCCESS':
  case 'UPDATE_GEO_OBJECT_SUCCESS':
    draft[action.geoObject.id] = action.geoObject
    return
  case 'DELETE_GEO_OBJECT_SUCCESS':
    delete draft[action.categoryId]
    return
  }
})